// extracted by mini-css-extract-plugin
export default {"root":"styles_root__G9tI-","tableContainer":"styles_tableContainer__4HEUS","btnWrap":"styles_btnWrap__HNIPK","disabled":"styles_disabled__NkLgC"};